import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RPCRequest } from '@campaign-portal/namespace/common/rpc.request';
import { RPCResult, RPCError } from '@campaign-portal/namespace/common/rpc.response';
import { Observable, map } from 'rxjs';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<RPCRequest>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			map((resp: HttpEvent<any>) => {
				if (resp instanceof HttpResponse && resp.body !== null) {
					if (this.hasRPCResult(resp)) {
						return this.createRPCResultResponse(resp.body.result);
					}
					if (this.hasRPCResultUR(resp)) {
						return this.createRPCResultResponseUR(resp.body.result);
					}
					if (this.hasCustomRPCResult(resp)) {
						return new HttpResponse<RPCResult<unknown>>({
							body: resp.body.result as RPCResult<unknown>,
						});
					}
					if (this.hasRPCError(resp)) {
						return new HttpResponse<RPCResult<unknown>>({
							body: {
								Success: false,
								Total: 0,
								Data: resp.body.error as RPCError,
							},
						});
					}
				}
				return resp;
			}),
		);
	}

	private createRPCResultResponse(rpcResult: { data: any[]; length: number }): HttpResponse<RPCResult<unknown>> {
		return new HttpResponse<RPCResult<unknown>>({
			body: {
				Success: !!rpcResult.data,
				Total: rpcResult.length,
				Data: rpcResult.data,
			},
		});
	}

	private createRPCResultResponseUR(rpcResult: { Data: any[]; Total: number }): HttpResponse<RPCResult<unknown>> {
		return new HttpResponse<RPCResult<unknown>>({
			body: {
				Success: !!rpcResult.Data,
				Total: rpcResult.Total,
				Data: rpcResult.Data,
			},
		});
	}

	private hasRPCResult(resp: HttpResponse<any>): boolean {
		return Object.hasOwn(resp.body, 'result') && Object.hasOwn(resp.body.result, 'data') && Object.hasOwn(resp.body.result, 'length');
	}

	private hasRPCResultUR(resp: HttpResponse<any>): boolean {
		return Object.hasOwn(resp.body, 'result') && Object.hasOwn(resp.body.result, 'Data') && Object.hasOwn(resp.body.result, 'Total');
	}

	private hasCustomRPCResult(resp: HttpResponse<any>): boolean {
		return Object.hasOwn(resp.body, 'result');
	}

	private hasRPCError(resp: HttpResponse<any>): boolean {
		return (
			Object.hasOwn(resp.body, 'error') &&
			Object.hasOwn(resp.body.error, 'code') &&
			Object.hasOwn(resp.body.error, 'message')
		);
	}
}